<div class="notification" [class.active]="active" (click)="active = false; userService.showNotification = false">
  <div class="notification-content">
    <div class="notification-title">{{title}}</div>
    <div class="notification-msg">{{message}}</div>
  </div>
</div>
